import BaseClient from './BaseClient';

class WorkflowSettingsClient extends BaseClient {
    get(teamId) {
        const url = `/api/v3/teams/${teamId}/workflow-settings`;
        return this.makeCoreApiRequest(url);
    }

    update(teamId, data) {
        const url = `/api/v3/teams/${teamId}/workflow-settings`;
        return this.makeCoreApiRequest(url, 'put', data);
    }
}

export default new WorkflowSettingsClient();
